/**
 * @module hasClientConfiguration
 */

import doesClientConfigurationExistInCache from './doesClientConfigurationExistInCache';
import doesClientConfigurationExistInStore from './doesClientConfigurationExistInStore';
import shouldRefreshClientConfiguration from './shouldRefreshClientConfiguration';
import refreshClientConfiguration from './refreshClientConfiguration';
import getClientConfigurationFromCache from '../selectors/getClientConfigurationFromCache';
import getClientConfigurationState from '../selectors/getClientConfigurationState';
import setClientConfiguration from '../mutators/setClientConfiguration';
import updateRequestState from '../mutators/updateRequestState';
import { ClientConfigurationRequestState } from '../store/schema/clientConfiguration';
import { ClientConfigurationCacheState } from '../store/schema/clientConfigurationCache';

/**
 * @function
 * To check whether the client configuration is present or not
 * @returns whether the client configuration is present
 */

const hasClientConfiguration = (): boolean => {
    if (doesClientConfigurationExistInStore()) {
        if (shouldRefreshClientConfiguration()) {
            refreshClientConfiguration();
        }
        const configState = getClientConfigurationState();
        return configState === ClientConfigurationCacheState.Success;
    } else if (doesClientConfigurationExistInCache()) {
        setClientConfiguration(getClientConfigurationFromCache());
        updateRequestState(ClientConfigurationRequestState.Resolved);
        if (shouldRefreshClientConfiguration()) {
            refreshClientConfiguration();
        }
        const configState = getClientConfigurationState();
        return configState === ClientConfigurationCacheState.Success;
    } else {
        refreshClientConfiguration();
        return false;
    }
};

export default hasClientConfiguration;
